export enum WorkFlowStatus {
  SCHEDULED = 'SCHEDULED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
  CANCELED = 'CANCELLED',
}
export type ItemCardProps = {
  date: string;
  title: string;
  doer?: string;
  inspector?: string;
  locations?: string[];
  projects?: string[];
  status: WorkFlowStatus;
  className?: string;
  role?: string;
  areaOfObservation?: string;
  onStatusClick?: (status: WorkFlowStatus) => void;
  onDownload?: () => void;
  onCancelOptionClick?: () => void;
  onRescheduleOptionClick?: () => void;
  onCardClick?: () => void;
  onContinueDraft?: () => void;
};
